import CountUp from "react-countup";
import Home from "assets/images/feature/home.svg";
import WorkForce from "assets/images/feature/workforce.svg";
import PinCode from "assets/images/feature/pincode.svg";
import TaskCompleted from "assets/images/feature/task-completed.svg";

const featureContent = [
  {
    image: Home,
    count: 500,
    suffix: "+",
    card_text: "Cities",
  },
  {
    image: WorkForce,
    count: 1,
    suffix: " Million+",
    card_text: "Workforce Count",
  },
  {
    image: PinCode,
    count: 13000,
    suffix: "+",
    card_text: "Pin Code",
  },
  {
    image: TaskCompleted,
    count: 20,
    suffix: " Million+",
    card_text: "Tasks Completed",
  },
];

const Feature = () => {
  return (
    <section className="section feature">
      <div className="container">
        <div className="row">
          {!!featureContent?.length &&
            featureContent?.map((feature, i) => {
              return (
                <div className="col-xl-3 col-md-6" key={i}>
                  <div
                    className="feature-item freelance-count aos"
                    data-aos="fade-up"
                  >
                    <div className="feature-icon">
                      <img
                        src={feature?.image}
                        className="img-fluid"
                        alt="icon"
                      />
                    </div>
                    <div className="feature-content course-count">
                      <h3 className="counter-up">
                        <span>
                          <CountUp end={feature?.count} suffix={feature?.suffix} />
                        </span>
                      </h3>
                      <p>{feature?.card_text}</p>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </section>
  );
};
export default Feature;
